/* Inside the main app layout, nested router to switch between the different main content sections */

import React from 'react';
import {
  Route,
  Switch,
} from 'react-router-dom';
import { HomeScreen } from 'AppSrc/core/components/home-screen/home-screen';
import { CrqsScreen } from 'AppSrc/core/components/crqs-screen/crqs-screen';
import { CreateCrqScreen } from 'AppSrc/core/components/create-crq-screen/create-crq-screen';
import { RouteForceLoadOnFirstStep } from 'AppSrc/core/components/router/force-load-on-first-step';
import { PageErrorScreen } from 'AppSrc/core/components/page-error-screen/page-error-screen';
import { DevOnlyRoute } from 'AppSrc/core/components/router/dev-only-route';
import { DevPage } from 'AppSrc/core/components/dev-page/dev-page';
import { CrqTransitionConfirmationScreen } from 'AppSrc/core/components/view-crq-screen/crq-transition-confirmation-screen';
import { ViewCrqScreen } from 'AppSrc/core/components/view-crq-screen/view-crq-screen';
import { EditCrqScreen } from 'AppSrc/core/components/edit-crq-screen/edit-crq-screen';
import { SearchCrqsScreen } from 'AppSrc/core/components/search-crqs-screen/search-crqs-screen';
import {
  VIEW_CRQ,
  EDIT_CRQ,
  CRQ_TRANSITION_CONFIRMATION,
  CRQS_SCREEN,
  SEARCH_CRQS,
  MY_CRQ,
  HELP_SECTION,
} from 'AppSrc/core/components/router/routes';
import { Help } from 'AppSrc/core/components/help-section/help';
import { MyCrqsScreen } from '../crqs-screen/my-crq-screen';



const MainContentRouter = React.memo(() => (
  <Switch>

    <Route exact path="/">
      <HomeScreen />
    </Route>

    <Route exact path={MY_CRQ.path}>
      <MyCrqsScreen />
    </Route>

    <Route exact path={HELP_SECTION.path}>
      <Help />
    </Route>

    <Route exact path={SEARCH_CRQS.path}>
      <SearchCrqsScreen />
    </Route>

    <Route exact path={CRQS_SCREEN.path}>
      <CrqsScreen />
    </Route>

    <Route
      exact
      path={CRQ_TRANSITION_CONFIRMATION.path}
      component={() => (
        <CrqTransitionConfirmationScreen />
      )}
    />

    <RouteForceLoadOnFirstStep
      path={['/crq/create/:crqNetwork/:stepId', '/crq/create']}
      component={() => (
        <CreateCrqScreen />
      )}
    />

    <Route
      exact
      path={VIEW_CRQ.path}
    >
      <ViewCrqScreen />
    </Route>

    <Route
      exact
      path={EDIT_CRQ.path}
    >
      <EditCrqScreen />
    </Route>

    <DevOnlyRoute
      path="/dev"
      component={() => (
        <DevPage />
      )}
    />

    <Route path="/unauthorised">
      <PageErrorScreen
        errorType="unauthorised"
      />
    </Route>

    <Route path={['*', '/notfound']}>
      <PageErrorScreen />
    </Route>

  </Switch>
));


export { MainContentRouter };
